module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yjl0wq/media/FC-9781645366799.jpg?1684515194357",
      "alt": "This image is the cover for the book The Virus of Beauty"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Virus of Beauty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Wilf Gilvary is a teenage wizard who is terrified of using magic. When his father dies under mysterious circumstances, Wilf is plunged into the middle of a political struggle between the witches and wizards in the magical realm. He'd rather play soccer than practice magic, but he's forced to make a choice between the life of a normal teen and one of wizardry after a powerful virus begins to decimate the witch community. The cure is spellbound in a journal Wilf inherited from his father and when his friend Katryna contracts the virus, Wilf understands that he must overcome his fear of magic to unlock the journal's secrets--but will it be too late to save her?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C. B. Lyall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("C. B. Lyall grew up in Stockton-on-Tees, England. Since then, she has lived in India, Belgium, Hong Kong, and the USA. She currently resides in the Hudson Valley, north of New York, with her husband. She has three adult sons and one grandson.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0